<template>
  <v-container grid-list-md>
    <pi-progress v-if="progress" main></pi-progress>
    <pi-navigation :navigation="navigation"></pi-navigation>

    <v-layout row wrap>
      <v-flex sm6>
        <v-card>
          <v-subheader>Informacje</v-subheader>
          <v-card-text>
            <v-form ref="infoForm" lazy-validation>
              <v-text-field
                v-model="userInfo.name"
                :rules="Rules.user.name"
                :disabled="progress"
                required
                prepend-icon="person"
                name="name"
                label="Imię"
              ></v-text-field>
              <v-text-field
                v-model="userInfo.surname"
                :rules="Rules.user.surname"
                :disabled="progress"
                required
                prepend-icon="person"
                name="surname"
                label="Nazwisko"
              ></v-text-field>
              <v-text-field
                v-model="userInfo.phone"
                :rules="Rules.user.phone"
                :disabled="progress"
                required
                prepend-icon="phone"
                name="phone"
                label="Telefon"
              ></v-text-field>
              <v-text-field
                v-model="userInfo.title"
                :rules="Rules.user.title"
                :disabled="progress"
                required
                prepend-icon="star"
                name="title"
                label="Stanowisko"
              ></v-text-field>
              <!-- <v-autocomplete
                :items="Rules.colors"
                v-model="userInfo.color"
                :rules="Rules.user.color"
                :disabled="progress"
                required
                prepend-icon="color_lens"
                name="color"
                label="Kolor"
                menu-props="auto"
                :color="userInfo.color"
                :class="'v-input--is-focused '+userInfo.color+'--text'"
              >
                <template v-slot:item="data">
                  <v-list-tile-action>
                    <v-icon :color="data.item">color_lens</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>{{ data.item }}</v-list-tile-content>
                </template>
              </v-autocomplete> -->
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex sm6>
        <v-card>
          <v-subheader>Logowanie</v-subheader>
          <v-card-text>
            <v-form ref="logForm" lazy-validation>
              <v-text-field
                v-model="userInfo.email"
                :rules="Rules.user.email"
                :disabled="progress || isCreating || !Auth.userData.superadmin"
                required
                prepend-icon="mail"
                name="email"
                label="Email"
              ></v-text-field>
              <v-switch
                v-if="Auth.userData.superadmin"
                :disabled="progress"
                color="accent"
                v-model="userInfo.superadmin"
                name="superadmin"
                label="Super admin"
              ></v-switch>
              <template v-if="isSelfEdit">
                <v-switch
                  :disabled="progress"
                  color="primary"
                  v-model="userLogin.changePassword"
                  name="changePassword"
                  label="Zmień hasło"
                ></v-switch>
                <v-text-field
                  v-model="userLogin.password"
                  :disabled="!userLogin.changePassword || progress"
                  required
                  :append-icon="userLogin.passwordV ? 'visibility' : 'visibility_off'"
                  @click:append="() => (userLogin.passwordV = !userLogin.passwordV)"
                  :type="userLogin.passwordV ? 'password' : 'text'"
                  min="8"
                  :rules="Rules.user.password"
                  prepend-icon="lock"
                  name="password"
                  label="Hasło"
                ></v-text-field>
                <v-text-field
                  v-model="userLogin.passwordConfirmation"
                  :disabled="!userLogin.changePassword || progress"
                  required
                  :append-icon="userLogin.passwordConfirmationV ? 'visibility' : 'visibility_off'"
                  @click:append="() => (userLogin.passwordConfirmationV = !userLogin.passwordConfirmationV)"
                  :type="userLogin.passwordConfirmationV ? 'password' : 'text'"
                  min="8"
                  :error-messages="userLogin.passwordConfirmationErrors"
                  prepend-icon="lock"
                  name="password_confirmation"
                  label="Potwierdzenie hasła"
                ></v-text-field>
              </template>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-btn color="accent" dark bottom right fab fixed @click="setData">
      <v-icon>save</v-icon>
    </v-btn>
    <pi-snackbar :color="snackbar.color" :snackbar.sync="snackbar.on" :message="snackbar.message"></pi-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    progress: false,
    snackbar: { on: false, color: "error", message: "" },
    userInfo: {
      email: "",
      name: "",
      surname: "",
      title: "",
      phone: "",
      // color: "teal",
      superadmin: false
    },
    userOriginal: {},
    userLogin: {
      changePassword: false,
      password: "",
      passwordV: true,
      passwordConfirmation: "",
      passwordConfirmationErrors: [],
      passwordConfirmationV: true
    },
    createId: 0,
    navigation: [],
    dataFetched: false
  }),
  computed: {
    passwordConfirmationValid() {
      return this.userLogin.password == this.userLogin.passwordConfirmation;
    },
    userId() {
      return this.isCreating
        ? this.createId
        : this.isSelfEdit
        ? this.Auth.userData.id
        : this.$route.params.userId;
    },
    userData() {
      const obj = {
        name: this.userInfo.name,
        surname: this.userInfo.surname,
        title: this.userInfo.title,
        phone: this.userInfo.phone,
        // color: this.userInfo.color,
        email: this.userInfo.email,
        superadmin: this.userInfo.superadmin
      };
      if (this.userLogin.changePassword) obj.password = this.userLogin.password;
      return obj;
    },
    superadminValue() {
      return this.userInfo.superadmin;
    },
    createEmail() {
      return this.$route.params.email;
    }
  },
  watch: {
    passwordConfirmationValid(v) {
      this.userLogin.passwordConfirmationErrors = v
        ? []
        : ["Potwierdzenie hasła nie jest zgodne z wpisanym hasłem"];
    },
    superadminValue(v) {
      if (!this.dataFetched || !this.isSelfEdit || v) return;
      this.showInfo(
        "Po zapisaniu nie ma możliwości samodzielnego przywrócenia uprawnień super administratora"
      );
    }
  },
  props: { isSelfEdit: Boolean, isCreating: Boolean },
  methods: {
    async getData() {
      if (this.isCreating) {
        this.userInfo.email = this.createEmail;
        return;
      }
      this.progress = true;
      const response = await this.Api.send("get", `/users/${this.userId}`);
      this.progress = false;
      if (response.status) {
        this.userInfo = { ...response.user };
        this.userOriginal = { ...response.user };
        this.dataFetched = true;
        return;
      }
      this.showError(response.message);
    },
    async setData() {
      if (
        !this.$refs.infoForm.validate() ||
        ((this.userLogin.changePassword || this.Auth.userData.superadmin) &&
          !this.$refs.logForm.validate())
      ) {
        return this.showError("Uzupełnij wymagane pola");
      }
      if (this.userLogin.changePassword && !this.passwordConfirmationValid) {
        return this.showError(
          "Potwierdzenie hasła nie jest zgodne z wpisanym hasłem"
        );
      }
      this.progress = true;
      const response = await this.Api.send(
        this.isCreating ? "post" : "put",
        this.isSelfEdit || this.isCreating ? "/users" : `/users/${this.userId}`,
        {
          userData: this.userData
        }
      );
      this.progress = false;
      if (response.status) {
        this.showSuccess(
          this.isCreating ? "Użytkownik dodany" : "Dane zmienione"
        );
        if (this.isCreating) this.$router.push({ path: "/user/all" });
        if (!this.isSelfEdit) return;
        this.Auth.setAuthData(response.user);
        this.userInfo = { ...response.user };
        this.userOriginal = { ...response.user };
        return;
      }
      this.showError(response.message);
    },
    async createNavigation() {
      this.navigation = [
        { id: 0, text: "Użytkownicy", href: "/user/all" },
        this.isSelfEdit
          ? {
              id: 1,
              text: "Edycja twoich danych",
              href: "/user/edit"
            }
          : this.isCreating
          ? {
              id: 1,
              text: "Tworzenie użytkownika",
              href: "/user/create",
              disabled: true
            }
          : {
              id: 1,
              text: `Edycja danych użytkownika ${this.userOriginal.name} ${
                this.userOriginal.surname
              }`,
              href: `/user/${this.userId}/edit`
            }
      ];
    },
    async showError(message) {
      this.snackbar.color = "error";
      this.showMessage(message);
    },
    async showSuccess(message) {
      this.snackbar.color = "success";
      this.showMessage(message);
    },
    async showInfo(message) {
      this.snackbar.color = "info";
      this.showMessage(message);
    },
    async showMessage(message) {
      this.snackbar.message = message;
      this.snackbar.on = true;
    }
  },
  async mounted() {
    // this.userInfo.color = this.Rules.colors[
    //   Math.floor(Math.random() * this.Rules.colors.length)
    // ];
    await this.getData();
    this.createNavigation();
  }
};
</script>
